import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.fabbench.objective.judge');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-fabbench-objective-judge',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.fabbench.objective.judge/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.benchmark-page {
  min-height: 100vh;
  background: radial-gradient(circle at 90% 0, rgba(6, 182, 212, 0.08), transparent 28rem), #f8fafc;
}

.progress-fill {
  transition: width 220ms ease;
}

.result-row {
  transition: background-color 140ms ease;
}

.result-row:hover {
  background: #f8fafc;
}

.truncate-answer {
  max-width: 34rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.manual-review-panel {
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28), 0 0 0 100vmax rgba(15, 23, 42, 0.42);
}

@media (max-width: 767px) {
  .details-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageFabbenchObjectiveJudgeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public judgeModes: any[] = [
        { value: 'LOCAL', label: 'Local Judge', description: 'Ollama Judge' },
        { value: 'OPENAI', label: 'OpenAI Judge', description: 'Strict Structured Output' },
        { value: 'COMPARE', label: 'Judge 비교', description: '동일 Gemma 답변 공정 비교' }
    ];
    public typeOptions: any[] = [
        { value: 'ALL', label: '전체 OBJECTIVE' },
        { value: 'Judge', label: 'True / False' },
        { value: 'Choice', label: 'Multiple Choice' },
        { value: 'Fill', label: 'Fill-in-the-Blank' },
        { value: 'Calculation', label: 'Calculation' }
    ];
    public scopeOptions: any[] = [
        { value: 'TEST_5', label: '우선 5문항 테스트', limit: 5 },
        { value: 'FULL', label: '선택 유형 전체 평가', limit: 0 }
    ];
    public metrics: any[] = [
        { key: 'factuality', label: 'Factuality', description: 'gold context 사실 일치' },
        { key: 'completeness', label: 'Completeness', description: '정답·설명·추론의 완전성' },
        { key: 'technical_depth', label: 'Technical Depth', description: '방법론·풀이 단계의 깊이' },
        { key: 'relevance', label: 'Relevance', description: '문항 형식과 요구사항 집중도' },
        { key: 'context_utilization', label: 'Context Utilization', description: 'gold context 통합 활용도' },
        { key: 'support_quality', label: 'Support Quality', description: '계산·공식·근거의 구체성' }
    ];
    public rubricRows: any[] = [
        { score: '9–10', completeness: '정답 + 완전한 설명·명확한 추론', depth: '정교한 이해 + 상세 방법론', relevance: '특정 문항 형식을 직접 충족', context: '여러 source를 매끄럽게 통합', support: '구체적 계산·공식으로 탁월하게 뒷받침' },
        { score: '7–8', completeness: '정답 + 좋은 설명, 경미한 누락', depth: '강한 분석 + 명확한 풀이 단계', relevance: '최소한의 이탈로 집중', context: '관련 context 대부분을 효과적으로 사용', support: '구체성이 좋은 강한 근거' },
        { score: '5–6', completeness: '기본 설명, 일부 세부 누락', depth: '합리적 기술 상세와 일부 분석', relevance: '대체로 답하나 불필요한 내용 존재', context: '핵심 context를 적절히 반영', support: '합리적 설명과 충분한 세부' },
        { score: '3–4', completeness: '부분 답변 또는 불완전한 설명', depth: '기본 접근이나 얕은 분석', relevance: '관련 없는 정보를 포함한 부분 답변', context: '일부 context만 사용, 통합 개선 필요', support: '일부 세부가 있으나 구체성 부족' },
        { score: '1–2', completeness: '최소 답변, 적절한 설명 부족', depth: '최소 분석, 피상적 접근', relevance: '상당히 벗어난 일부 관련 내용', context: '가용 context의 효과적 사용이 미미', support: '근거가 미미하거나 설명이 부실' },
        { score: '0', completeness: '명확한 답 없음 또는 무관', depth: '의미 있는 분석 없음', relevance: '특정 요구사항을 충족하지 못함', context: 'context를 완전히 무시하거나 모순', support: '근거가 없거나 오해를 유발' }
    ];

    public selectedJudgeMode: string = 'OPENAI';
    public selectedJudgeModel: string = '';
    public selectedType: string = 'ALL';
    public evaluationScope: string = 'TEST_5';
    public resultFilter: string = 'ALL';
    public benchmark: any = {
        available: false,
        counts: {},
        category_counts: {},
        total_objective: 0,
        generator_model: 'gemma4:26b-a4b-it-q8_0',
        score_min: 0,
        score_max: 10,
        normalization_divisor: 10,
        rubric_version: '',
        scoring_version: '',
        openai_judge: { model: '', api_key_configured: false }
    };
    public ollamaModels: any[] = [];
    public cases: any[] = [];
    public results: any[] = [];
    public comparisonResults: any[] = [];
    public summary: any = this.emptySummary();
    public comparisonSummary: any = this.emptyComparisonSummary();
    public loading: boolean = true;
    public modelsLoading: boolean = false;
    public running: boolean = false;
    public cancelRequested: boolean = false;
    public activeCase: any = null;
    public selectedResult: any = null;
    public error: string = '';
    public notice: string = '';
    public modelError: string = '';
    public savedFiles: any[] = [];
    public runStartedAt: string = '';
    public runCompletedAt: string = '';
    public runId: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.loadModels();
        await this.loadBenchmark();
    }

    public async loadModels(force: boolean = false) {
        if (this.running) return;
        this.modelsLoading = true;
        this.modelError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('ollama_models', { force: force ? 'true' : 'false' });
            if (response && response.code === 200) {
                this.ollamaModels = response.data.models || [];
                const selectable = this.ollamaModels.filter((item: any) => item.available_for_judge);
                if (!selectable.some((item: any) => item.name === this.selectedJudgeModel)) {
                    this.selectedJudgeModel = response.data.default_model || (selectable[0] && selectable[0].name) || '';
                }
                if (!this.selectedJudgeModel) this.modelError = 'Generator와 다른 Local Judge 모델이 필요합니다.';
            } else {
                this.modelError = this.errorMessage(response, 'Ollama 모델 목록을 불러오지 못했습니다.');
            }
        } catch (error) {
            this.modelError = 'Ollama 모델 목록 요청 중 네트워크 오류가 발생했습니다.';
        }
        this.modelsLoading = false;
        await this.service.render();
    }

    public async loadBenchmark() {
        if (this.running) return;
        this.loading = true;
        this.error = '';
        const types = this.selectedType === 'ALL' ? [] : [this.selectedType];
        await this.service.render();
        try {
            const response: any = await wiz.call('benchmark', { types: JSON.stringify(types) });
            if (response && response.code === 200) {
                this.benchmark = response.data.benchmark || this.benchmark;
                this.cases = response.data.cases || [];
            } else {
                this.cases = [];
                this.error = this.errorMessage(response, 'FAB-Bench OBJECTIVE 데이터셋을 불러오지 못했습니다.');
            }
        } catch (error) {
            this.cases = [];
            this.error = 'OBJECTIVE 데이터셋 요청 중 네트워크 오류가 발생했습니다.';
        }
        this.resetRun();
        this.loading = false;
        await this.service.render();
    }

    public async changeType() {
        await this.loadBenchmark();
    }

    public changeJudgeMode() {
        this.resetRun();
        this.error = '';
        this.notice = '';
    }

    public usesLocalJudge() {
        return this.selectedJudgeMode === 'LOCAL' || this.selectedJudgeMode === 'COMPARE';
    }

    public usesOpenAIJudge() {
        return this.selectedJudgeMode === 'OPENAI' || this.selectedJudgeMode === 'COMPARE';
    }

    public openAIConfig() {
        return this.benchmark.openai_judge || {};
    }

    public runCases() {
        const option = this.scopeOptions.find((item: any) => item.value === this.evaluationScope);
        const limit = option ? option.limit : 5;
        return limit ? this.cases.slice(0, limit) : this.cases.slice();
    }

    public canStart() {
        if (this.loading || this.running || !this.benchmark.available || !this.runCases().length) return false;
        if (this.usesLocalJudge() && !this.selectedJudgeModel) return false;
        if (this.usesOpenAIJudge() && !this.openAIConfig().api_key_configured) return false;
        return true;
    }

    public async startEvaluation() {
        if (!this.canStart()) return;
        this.resetRun();
        this.running = true;
        this.cancelRequested = false;
        this.error = '';
        this.notice = '';
        this.runStartedAt = new Date().toISOString();
        this.runId = 'objective-rubric-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        await this.service.render();

        for (const item of this.runCases()) {
            if (this.cancelRequested) break;
            this.activeCase = item;
            await this.service.render();
            const endpoint = this.selectedJudgeMode === 'LOCAL'
                ? 'evaluate_local'
                : (this.selectedJudgeMode === 'OPENAI' ? 'evaluate_openai' : 'evaluate_comparison');
            const params: any = {
                test_id: item.test_id,
                request_token: this.runId + ':' + this.selectedJudgeMode.toLowerCase() + ':' + item.test_id
            };
            if (this.usesLocalJudge()) params.judge_model = this.selectedJudgeModel;
            let response: any = null;
            try {
                response = await wiz.call(endpoint, params);
            } catch (error) {
                response = null;
            }
            if (response && response.code === 200 && response.data.result) {
                if (this.selectedJudgeMode === 'COMPARE') this.comparisonResults.push(response.data.result);
                else this.results.push(response.data.result);
            } else if (this.selectedJudgeMode === 'COMPARE') {
                this.comparisonResults.push(this.failedComparison(item, this.errorMessage(response, '평가 요청에 실패했습니다.')));
            } else {
                this.results.push(this.failedResult(item, this.errorMessage(response, '평가 요청에 실패했습니다.')));
            }
            this.recalculateSummary();
            await this.service.render();
        }

        this.activeCase = null;
        this.running = false;
        this.runCompletedAt = new Date().toISOString();
        const count = this.resultCount();
        this.notice = this.cancelRequested
            ? count + '문항까지 평가하고 중지했습니다.'
            : count + '문항의 Appendix E OBJECTIVE 평가를 완료했습니다.';
        await this.service.render();
        if (count) await this.saveResults('json', true);
    }

    public async stopEvaluation() {
        if (!this.running) return;
        this.cancelRequested = true;
        this.notice = '현재 문항 응답이 끝난 뒤 중지합니다.';
        await this.service.render();
    }

    public async saveResults(format: string, automatic: boolean = false) {
        const payload = this.selectedJudgeMode === 'COMPARE' ? this.comparisonResults : this.results;
        if (!payload.length) return;
        try {
            const response: any = await wiz.call('save', {
                results: JSON.stringify(payload),
                format,
                metadata: JSON.stringify({
                    judge_mode: this.selectedJudgeMode,
                    judge_model: this.selectedJudgeModel,
                    openai_judge_model: this.openAIConfig().model || '',
                    selected_type: this.selectedType,
                    evaluation_scope: this.evaluationScope,
                    started_at: this.runStartedAt,
                    completed_at: this.runCompletedAt,
                    cancelled: this.cancelRequested
                })
            });
            if (response && response.code === 200) {
                const saved = response.data.saved;
                this.savedFiles.unshift(saved);
                if (!automatic) this.notice = saved.path + '에 저장했습니다.';
            } else if (!automatic) {
                this.error = this.errorMessage(response, '평가 결과를 저장하지 못했습니다.');
            }
        } catch (error) {
            if (!automatic) this.error = '평가 결과 저장 요청 중 네트워크 오류가 발생했습니다.';
        }
        await this.service.render();
    }

    public recalculateSummary() {
        if (this.selectedJudgeMode === 'COMPARE') {
            const local = this.comparisonResults.map((row: any) => row.local_judge || {});
            const openai = this.comparisonResults.map((row: any) => row.openai_judge || {});
            const paired = this.comparisonResults.filter((row: any) => row.both_scored);
            const differences: any = {};
            for (const metric of this.metrics) {
                const values = paired
                    .map((row: any) => (row.score_differences || {})[metric.key])
                    .filter((value: any) => this.isNumeric(value));
                differences[metric.key] = values.length
                    ? this.round(values.reduce((sum: number, value: number) => sum + Number(value), 0) / values.length, 2)
                    : 0;
            }
            const typeSummaries = this.typeOptions
                .filter((option: any) => option.value !== 'ALL')
                .map((option: any) => {
                    const rows = this.comparisonResults.filter(
                        (row: any) => row.question_type === option.value
                    );
                    return {
                        question_type: option.value,
                        label: this.displayType(option.value),
                        total: rows.length,
                        paired_scored: rows.filter((row: any) => row.both_scored).length,
                        local: this.summarize(rows.map((row: any) => row.local_judge || {})),
                        openai: this.summarize(rows.map((row: any) => row.openai_judge || {}))
                    };
                })
                .filter((item: any) => item.total > 0);
            this.comparisonSummary = {
                total: this.comparisonResults.length,
                paired_scored: paired.length,
                local: this.summarize(local),
                openai: this.summarize(openai),
                metric_differences: differences,
                type_summaries: typeSummaries
            };
        } else {
            this.summary = this.summarize(this.results);
        }
    }

    public summarize(rows: any[]) {
        const scored = rows.filter((row: any) => row.status === 'SCORED');
        const averages: any = {};
        for (const metric of this.metrics) {
            const values = scored
                .map((row: any) => (row.judge_scores || {})[metric.key])
                .filter((value: any) => this.isNumeric(value));
            averages[metric.key] = values.length
                ? this.round(values.reduce((sum: number, value: number) => sum + Number(value), 0) / values.length, 2)
                : 0;
        }
        const overallValues = scored
            .map((row: any) => row.average_score)
            .filter((value: any) => this.isNumeric(value));
        const overall = overallValues.length
            ? this.round(overallValues.reduce((sum: number, value: number) => sum + Number(value), 0) / overallValues.length, 2)
            : 0;
        return {
            total: rows.length,
            scored: scored.length,
            errors: rows.length - scored.length,
            metric_averages: averages,
            overall_average: overall,
            overall_normalized: this.round(overall / 10, 4),
            overall_score_100: this.round(overall * 10, 2)
        };
    }

    public emptySummary() {
        return {
            total: 0,
            scored: 0,
            errors: 0,
            metric_averages: this.emptyMetricValues(),
            overall_average: 0,
            overall_normalized: 0,
            overall_score_100: 0
        };
    }

    public emptyComparisonSummary() {
        return {
            total: 0,
            paired_scored: 0,
            local: this.emptySummary(),
            openai: this.emptySummary(),
            metric_differences: this.emptyMetricValues(),
            type_summaries: []
        };
    }

    public resetRun() {
        this.results = [];
        this.comparisonResults = [];
        this.summary = this.emptySummary();
        this.comparisonSummary = this.emptyComparisonSummary();
        this.activeCase = null;
        this.selectedResult = null;
        this.cancelRequested = false;
        this.savedFiles = [];
        this.runStartedAt = '';
        this.runCompletedAt = '';
    }

    public emptyMetricValues() {
        const values: any = {};
        for (const metric of this.metrics) values[metric.key] = 0;
        return values;
    }

    public failedResult(item: any, message: string) {
        return {
            test_id: item.test_id,
            test_type: item.test_type,
            question_type: item.question_type,
            category: (item.test_id || '').split('_')[0],
            question: item.question,
            gemma_answer: '',
            ground_truth: '',
            judge_scores: {},
            judge_scores_normalized: {},
            judge_reasons: {},
            average_score: null,
            normalized_score: null,
            status: 'API_ERROR',
            error_stage: 'request',
            error: message
        };
    }

    public failedComparison(item: any, message: string) {
        const local: any = this.failedResult(item, message);
        const openai: any = this.failedResult(item, message);
        local.judge_provider = 'local';
        openai.judge_provider = 'openai';
        return {
            test_id: item.test_id,
            test_type: item.test_type,
            question_type: item.question_type,
            category: (item.test_id || '').split('_')[0],
            question: item.question,
            gemma_answer: '',
            ground_truth: '',
            local_judge: local,
            openai_judge: openai,
            both_scored: false,
            score_differences: {},
            overall_difference: null
        };
    }

    public resultCount() {
        return this.selectedJudgeMode === 'COMPARE' ? this.comparisonResults.length : this.results.length;
    }

    public progressPercent() {
        const total = this.runCases().length;
        return total ? Math.min(100, Math.round(this.resultCount() / total * 100)) : 0;
    }

    public displayType(value: string) {
        const labels: any = { Judge: 'True/False', Choice: 'Choice', Fill: 'Fill', Calculation: 'Calculate' };
        return labels[value] || value || '-';
    }

    public typeCount(value: string) {
        return Number((this.benchmark.counts || {})[value] || 0);
    }

    public currentSummary() {
        if (this.selectedJudgeMode === 'COMPARE') return this.comparisonSummary.openai;
        return this.summary;
    }

    public resultRows() {
        return this.selectedJudgeMode === 'COMPARE' ? this.comparisonResults : this.results;
    }

    public selectResult(row: any) {
        this.selectedResult = row;
    }

    public closeResult() {
        this.selectedResult = null;
    }

    public detailResult(provider: string = '') {
        if (!this.selectedResult) return {};
        if (this.selectedJudgeMode !== 'COMPARE') return this.selectedResult;
        return provider === 'local'
            ? (this.selectedResult.local_judge || {})
            : (this.selectedResult.openai_judge || {});
    }

    public score(row: any, metric: string) {
        return (row && row.judge_scores && this.isNumeric(row.judge_scores[metric]))
            ? row.judge_scores[metric]
            : '-';
    }

    public normalizedScore(row: any, metric: string) {
        return (row && row.judge_scores_normalized && this.isNumeric(row.judge_scores_normalized[metric]))
            ? Number(row.judge_scores_normalized[metric]).toFixed(2)
            : '-';
    }

    public reason(row: any, metric: string) {
        return (row && row.judge_reasons && row.judge_reasons[metric]) || '평가 근거 없음';
    }

    public rowStatus(row: any) {
        if (this.selectedJudgeMode === 'COMPARE') {
            return row.both_scored ? 'SCORED' : 'ERROR';
        }
        return row.status || 'ERROR';
    }

    public rowOverall(row: any) {
        if (this.selectedJudgeMode === 'COMPARE') {
            return this.rowProviderOverall(row, 'openai');
        }
        return this.isNumeric(row.average_score) ? Number(row.average_score).toFixed(2) : '-';
    }

    public rowProviderOverall(row: any, provider: string) {
        const result = provider === 'local'
            ? (row && row.local_judge)
            : (row && row.openai_judge);
        return result && this.isNumeric(result.average_score)
            ? Number(result.average_score).toFixed(2)
            : '-';
    }

    public summaryOverall(summary: any) {
        return summary && summary.scored && this.isNumeric(summary.overall_average)
            ? Number(summary.overall_average).toFixed(2)
            : '-';
    }

    public rowNormalized(row: any) {
        const overall = this.rowOverall(row);
        return overall === '-' ? '-' : (Number(overall) / 10).toFixed(2);
    }

    public statusClass(status: string) {
        return status === 'SCORED'
            ? 'bg-emerald-100 text-emerald-700'
            : 'bg-rose-100 text-rose-700';
    }

    public scoreClass(value: any) {
        const score = Number(value);
        if (!this.isNumeric(value)) return 'text-slate-300';
        if (score >= 8) return 'text-emerald-700';
        if (score >= 5) return 'text-amber-700';
        return 'text-rose-700';
    }

    public modelLabel(model: any) {
        return model.name + (model.available_for_judge ? '' : ' — ' + (model.unavailable_reason || '사용 불가'));
    }

    public isNumeric(value: any) {
        return value !== null && value !== '' && !isNaN(Number(value));
    }

    public round(value: number, digits: number) {
        const unit = Math.pow(10, digits);
        return Math.round((value + Number.EPSILON) * unit) / unit;
    }

    public errorMessage(response: any, fallback: string) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.message) return response.message;
        return fallback;
    }

    public trackRow(index: number, row: any) {
        return row.test_id || index;
    }
}

export default PageFabbenchObjectiveJudgeComponent;